import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import Plus from '../../assets/images/Plus.png';
import Search from '../../assets/images/search.png';
import { useNavigate } from 'react-router-dom';
import React, { useState, Component, useEffect, useRef, useCallback } from 'react';
import moment from 'moment/moment';
import Modal from 'react-bootstrap/Modal';
import logo from '../../assets/images/pro360.png';
import jsPDF from 'jspdf';
import { getUserId } from '../../../Redux/selecters';
import { useSelector } from 'react-redux';
import ApiService from '../../services/apiService';
import { toast } from 'react-toastify';
import userManagement from '../../services/userManagement';
import {
  FaDownload,
  FaEye,
  FaFilePdf,
  FaFileExcel,
  FaMinus,
  FaReceipt,
  FaPrint,
  FaCalendarAlt,
  FaClock,
  FaUser,
  FaBuilding,
  FaHashtag,
  FaDollarSign,
  FaArrowDown,
} from 'react-icons/fa';

const PayOut = () => {
  let navigate = useNavigate();
  const [day, setDayOpen] = useState([]);
  const [employee, setEmployee] = useState([]);
  const [loading, setLoading] = useState(false);
  const [value, setvalue] = useState();
  const modalRef = useRef();
  const gridRef = useRef();
  const userId = useSelector(getUserId);
  const [show, setShow] = useState(false);
  let token = localStorage.getItem('Token');

  const handleClose = () => setShow(false);

  useEffect(() => {
    GetDayOpen();
    GetEmployee();
  }, []);

  const GetDayOpen = async () => {
    try {
      setLoading(true);
      const apiService = new ApiService();
      let param = `?Type=${6}&UserId=${userId}&GetMultiple=${true}`;
      let res = await apiService.getApiParamater('GET_CASH', param);
      if (res?.data?.result) {
        setDayOpen(res.data.result.reverse());
      } else {
        setDayOpen([]);
      }
    } catch (error) {
      console.error('Error fetching payout data:', error);
      toast.error('Failed to fetch pay-out records');
      setDayOpen([]);
    } finally {
      setLoading(false);
    }
  };

  const GetEmployee = async () => {
    try {
      const apiService = new ApiService();
      let param = `?UserId=${userId}`;
      let res = await apiService.getApiParamater('GET_EMPLOYEE', param);
      if (res?.data?.result && res.data.result.length > 0) {
        setEmployee(res.data.result[0]);
      }
    } catch (error) {
      console.error('Error fetching Employee:', error);
      toast.error('Failed to fetch employee data');
    }
  };

  const dateFormatter = (params) => {
    const date = moment(params.value);
    return date.format('MMM Do YYYY, h:mm A');
  };

  const dateComparator = (date1, date2) => {
    const momentDate1 = moment(date1);
    const momentDate2 = moment(date2);
    return momentDate1.isSame(momentDate2) ? 0 : momentDate1.isBefore(momentDate2) ? -1 : 1;
  };

  const handleShow = (rowData) => {
    setvalue(rowData);
    setShow(true);
  };

  const handlePayOutform = () => {
    navigate('/Cashier/PayOutForm');
  };

  const handleDownload = () => {
    if (!value) {
      toast.error('No data to download');
      return;
    }

    try {
      const pdf = new jsPDF();

      // Enhanced PDF styling
      pdf.setFont('helvetica');

      // Logo
      const logoWidth = 20;
      const logoHeight = 25;
      const logoX = (pdf.internal.pageSize.width - logoWidth) / 2;
      const logoY = 15;
      pdf.addImage(logo, 'PNG', logoX, logoY, logoWidth, logoHeight);

      // Title
      pdf.setFontSize(20);
      pdf.setTextColor(220, 53, 69); // Red color for pay-out
      pdf.text('Pay-Out Receipt', pdf.internal.pageSize.width / 2, logoY + logoHeight + 15, { align: 'center' });

      // Content with better formatting
      pdf.setFontSize(12);
      pdf.setTextColor(0, 0, 0);
      const startX = 20;
      let currentY = logoY + logoHeight + 35;

      const addLine = (label, value, icon = '') => {
        pdf.setFont('helvetica', 'bold');
        pdf.text(`${icon} ${label}:`, startX, currentY);
        pdf.setFont('helvetica', 'normal');
        pdf.text(value, startX + 60, currentY);
        currentY += 12;
      };

      addLine('Date', moment(value?.openingDate).format('MMMM Do YYYY'), '📅');
      addLine('Time', moment(value?.openingDate).format('h:mm A'), '🕐');
      addLine('Voucher No', `VOC-${value?.voucherNo}`, '🎫');
      addLine('From User', userManagement.getUserName(token) || value?.userId, '👤');
      addLine('Amount', `$${value?.amount}`, '💰');
      addLine('Shift', employee?.shiftNumber || 'N/A', '⏰');
      addLine('Branch', employee?.branchName || 'N/A', '🏢');
      addLine('Company', employee?.restaurantName || 'N/A', '🏢');
      addLine('ID', value?.id, '#️⃣');

      // Footer
      currentY += 10;
      pdf.setFontSize(10);
      pdf.setTextColor(128, 128, 128);
      pdf.text('Generated on ' + moment().format('MMMM Do YYYY, h:mm A'), pdf.internal.pageSize.width / 2, currentY, { align: 'center' });

      pdf.save(`PayOut_${value?.id}_receipt.pdf`);
      toast.success('Receipt downloaded successfully');
    } catch (error) {
      console.error('Error generating PDF:', error);
      toast.error('Failed to generate receipt');
    }
  };

  // Enhanced CSV Export
  const onBtnCSVExport = useCallback(() => {
    if (gridRef.current) {
      gridRef.current.api.exportDataAsCsv({
        fileName: `PayOut_Records_${moment().format('YYYY-MM-DD')}.csv`,
      });
      toast.success('CSV exported successfully');
    }
  }, []);

  // Enhanced Excel Export
  const onBtExcelExport = useCallback(() => {
    if (gridRef.current) {
      gridRef.current.api.exportDataAsExcel({
        fileName: `PayOut_Records_${moment().format('YYYY-MM-DD')}.xlsx`,
      });
      toast.success('Excel file exported successfully');
    }
  }, []);

  // Enhanced Amount Cell Renderer (negative for pay-out)
  const AmountCellRenderer = (props) => {
    const amount = props.value;
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          fontWeight: '700',
          color: '#6E5199', // Red for pay-out
        }}
      >
        <FaArrowDown size={14} />
        <span>-{amount}</span>
      </div>
    );
  };

  // Enhanced Voucher Cell Renderer
  const VoucherCellRenderer = (props) => {
    const voucherNo = props.data.voucherNo;
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          fontWeight: '600',
          color: '#6E5199', // Red theme for pay-out
        }}
      >
        <FaReceipt size={14} />
        <span>VOC-{voucherNo}</span>
      </div>
    );
  };

  // Enhanced Date Cell Renderer
  const DateCellRenderer = (props) => {
    const date = moment(props.value);
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          fontSize: '13px',
        }}
      >
        <FaCalendarAlt size={12} color="#6c757d" />
        <div>
          <div style={{ fontWeight: '600', color: '#495057' }}>{date.format('MMM Do YYYY')}</div>
          <div style={{ fontSize: '11px', color: '#6c757d' }}>{date.format('h:mm A')}</div>
        </div>
      </div>
    );
  };

  const columnDefs = [
    {
      headerName: 'Pay-Out ID',
      field: 'id',
      filter: true,
      floatingFilter: true,
      minWidth: 150,
      cellStyle: { fontWeight: '700', color: '#495057' },
    },
    {
      headerName: 'Voucher Code',
      field: 'voucherNo',
      filter: true,
      floatingFilter: true,
      minWidth: 180,
      cellRenderer: VoucherCellRenderer,
    },
    {
      headerName: 'Remarks',
      field: 'remarks',
      filter: true,
      floatingFilter: true,
      minWidth: 250,
      cellStyle: { fontSize: '13px', color: '#6c757d' },
    },
    {
      headerName: 'Date & Time',
      field: 'openingDate',
      filter: true,
      floatingFilter: true,
      minWidth: 200,
      cellRenderer: DateCellRenderer,
      comparator: dateComparator,
    },
    {
      headerName: 'Amount',
      field: 'amount',
      filter: 'agNumberColumnFilter',
      floatingFilter: true,
      minWidth: 150,
      cellRenderer: AmountCellRenderer,
      cellStyle: { textAlign: 'right' },
    },
    {
      headerName: 'Actions',
      field: 'id',
      cellRenderer: BtnCellRenderer,
      cellRendererParams: {
        clicked: function (field) {
          handleShow(field);
        },
      },
      minWidth: 120,
      pinned: 'right',
      cellStyle: { textAlign: 'center' },
    },
  ];

  const transformed = day?.map((day) => {
    return {
      ...day,
      id: `P-OUT-${day.id}`,
      amount: Number(day.amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
    };
  });

  return (
    <>
      {/* Enhanced Header Section */}
      <div
        className="d-flex justify-content-between align-items-center"
        style={{
          padding: '24px 30px',
          background: '#fff',
          borderRadius: '12px',
          marginBottom: '24px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
          border: '1px solid #e9ecef',
          margin: '20px',
        }}
      >
        <div className="d-flex gap-4 align-items-center">
          <div>
            <h4
              style={{
                color: '#495057',
                fontWeight: '700',
                margin: 0,
                fontSize: '28px',
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
              }}
            >
              <FaArrowDown style={{ color: '#6E5199' }} />
              Pay-Out Management
            </h4>
            <p
              style={{
                color: '#6c757d',
                margin: 0,
                fontSize: '16px',
                marginTop: '4px',
              }}
            >
              Track and manage cash pay-out transactions
            </p>
          </div>

          {loading && (
            <div className="d-flex align-items-center">
              <div className="spinner-border spinner-border-sm text-danger me-2"></div>
              <span style={{ fontSize: '14px', color: '#6c757d' }}>Loading...</span>
            </div>
          )}
        </div>

        <div className="d-flex gap-3 align-items-center">
          {/* Enhanced Pay Out Button */}
          <button
            className="d-flex align-items-center gap-2"
            onClick={handlePayOutform}
            style={{
              background: 'linear-gradient(135deg, #6E5199 0%,rgb(144, 105, 203) 100%)',
              color: 'white',
              border: 'none',
              borderRadius: '10px',
              padding: '14px 24px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 12px rgba(144, 105, 203, 0.74)',
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 6px 16px rgba(144, 105, 203, 0.74)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 12px rgba(144, 105, 203, 0.74)';
            }}
          >
            <FaMinus size={16} />
            <span>New Pay-Out</span>
          </button>

          {/* Enhanced Export Buttons */}
          <div className="d-flex gap-2">
            <button
              onClick={onBtExcelExport}
              className="btn btn-outline-success"
              style={{
                borderRadius: '8px',
                padding: '10px 16px',
                fontSize: '14px',
                fontWeight: '600',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                transition: 'all 0.2s ease',
              }}
            >
              <FaFileExcel size={14} />
              Excel
            </button>

            <button
              onClick={onBtnCSVExport}
              className="btn btn-outline-primary"
              style={{
                borderRadius: '8px',
                padding: '10px 16px',
                fontSize: '14px',
                fontWeight: '600',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                transition: 'all 0.2s ease',
              }}
            >
              <FaFilePdf size={14} />
              CSV
            </button>
          </div>
        </div>
      </div>

      {/* Enhanced Data Grid */}
      <div className="px-5">
        <div
          className="mt-3"
          style={{
            background: '#fff',
            borderRadius: '12px',
            overflow: 'hidden',
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
            border: '1px solid #e9ecef',
          }}
        >
          {day.length === 0 && !loading ? (
            <div className="text-center py-5" style={{ padding: '80px 20px' }}>
              <div
                style={{
                  fontSize: '64px',
                  opacity: '0.3',
                  color: '#6E5199',
                  marginBottom: '20px',
                }}
              >
                💸
              </div>
              <h5
                className="mt-3"
                style={{
                  color: '#495057',
                  fontWeight: '600',
                  marginBottom: '8px',
                }}
              >
                No Pay-Out Records Found
              </h5>
              <p
                style={{
                  color: '#6c757d',
                  fontSize: '16px',
                  marginBottom: '24px',
                }}
              >
                Start by creating your first pay-out transaction
              </p>
              <button
                onClick={handlePayOutform}
                className="btn"
                style={{
                  background: 'linear-gradient(135deg, #6E5199 0%, #6E5199 100%)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  padding: '12px 24px',
                  fontSize: '14px',
                  fontWeight: '600',
                }}
              >
                <FaMinus className="me-2" />
                Create Pay-Out
              </button>
            </div>
          ) : (
            <div
              className="ag-theme-alpine"
              style={{
                height: 750,
                '--ag-header-background-color': '#f8f9fa',
                '--ag-header-foreground-color': '#495057',
                '--ag-border-color': '#e9ecef',
                '--ag-row-hover-color': '#fff5f5',
                '--ag-font-family': 'inherit',
              }}
            >
              <AgGridReact
                ref={gridRef}
                columnDefs={columnDefs}
                rowData={transformed}
                pagination={true}
                paginationPageSize={20}
                rowHeight={65}
                headerHeight={50}
                suppressRowClickSelection={true}
                enableFilter={true}
                floatingFilter={true}
                animateRows={true}
                defaultColDef={{
                  resizable: true,
                  sortable: true,
                  filter: true,
                }}
                loadingOverlayComponent={'Loading pay-out records...'}
              />
            </div>
          )}
        </div>
      </div>

      {/* Enhanced Modal */}
      <Modal show={show} onHide={handleClose} size="md" centered ref={modalRef} backdrop="static">
        <div
          style={{
            background: 'linear-gradient(135deg, #6E5199 0%,rgb(51, 37, 72) 100%)',
            color: 'white',
            padding: '24px',
            borderRadius: '12px 12px 0 0',
          }}
        >
          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center gap-3">
              <FaCalendarAlt size={18} />
              <div>
                <div style={{ fontSize: '16px', fontWeight: '600' }}>{moment.utc(value?.openingDate).local().format('MMM Do YYYY')}</div>
                <div style={{ fontSize: '14px', opacity: '0.9' }}>Pay-Out Transaction</div>
              </div>
            </div>

            <div className="text-center">
              <img width={80} height={50} src={logo} style={{ filter: 'brightness(0) invert(1)' }} alt="Logo" />
            </div>

            <div className="d-flex align-items-center gap-3">
              <FaClock size={18} />
              <div>
                <div style={{ fontSize: '16px', fontWeight: '600' }}>{moment.utc(value?.openingDate).local().format('h:mm A')}</div>
                <div style={{ fontSize: '14px', opacity: '0.9' }}>Time</div>
              </div>
            </div>
          </div>
        </div>

        <Modal.Body style={{ padding: '32px' }}>
          <div className="receipt-content">
            <div className="mb-4 text-center">
              <div
                style={{
                  background: 'linear-gradient(135deg, #f8d7da 0%, #f5c6cb 100%)',
                  padding: '20px',
                  borderRadius: '12px',
                  border: '2px solid #6E5199',
                }}
              >
                <div
                  style={{
                    fontSize: '18px',
                    fontWeight: '700',
                    color: '#6E5199',
                    marginBottom: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                  }}
                >
                  <FaReceipt />
                  Voucher No: VOC-{value?.voucherNo}
                </div>
              </div>
            </div>

            <div className="transaction-details">
              {[
                { icon: FaUser, label: 'From User', value: userManagement.getUserName(token) || value?.userId },
                { icon: FaArrowDown, label: 'Amount', value: `$${value?.amount}`, highlight: true },
                { icon: FaClock, label: 'Shift', value: employee?.shiftNumber || 'N/A' },
                { icon: FaBuilding, label: 'Branch', value: employee?.branchName || 'N/A' },
                { icon: FaBuilding, label: 'Company', value: employee?.restaurantName || 'N/A' },
                { icon: FaHashtag, label: 'Transaction ID', value: value?.id },
              ].map((item, index) => (
                <div
                  key={index}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '16px',
                    margin: '8px 0',
                    background: item.highlight ? 'linear-gradient(135deg, #f8d7da 0%, #f5c6cb 100%)' : '#f8f9fa',
                    borderRadius: '8px',
                    border: item.highlight ? '2px solid #6E5199' : '1px solid #e9ecef',
                  }}
                >
                  <item.icon
                    size={20}
                    style={{
                      marginRight: '12px',
                      color: item.highlight ? '#6E5199' : '#6c757d',
                    }}
                  />
                  <div style={{ flex: 1 }}>
                    <div
                      style={{
                        fontSize: '14px',
                        color: '#6c757d',
                        fontWeight: '500',
                      }}
                    >
                      {item.label}
                    </div>
                    <div
                      style={{
                        fontSize: '16px',
                        fontWeight: '700',
                        color: item.highlight ? '#6E5199' : '#495057',
                        marginTop: '2px',
                      }}
                    >
                      {item.highlight && '-'}
                      {item.value}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div
              style={{
                marginTop: '24px',
                padding: '16px',
                background: '#f8f9fa',
                borderRadius: '8px',
                textAlign: 'center',
                fontSize: '12px',
                color: '#6c757d',
              }}
            >
              Generated on {moment().format('MMMM Do YYYY, h:mm A')}
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer
          style={{
            padding: '24px',
            borderTop: '1px solid #e9ecef',
            background: '#f8f9fa',
          }}
        >
          <div className="d-flex gap-3 w-100 justify-content-center">
            <button
              className="btn"
              onClick={handleClose}
              style={{
                background: '#6c757d',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                padding: '12px 24px',
                fontSize: '14px',
                fontWeight: '600',
              }}
            >
              Close
            </button>
            <button
              className="btn"
              onClick={handleDownload}
              style={{
                background: 'linear-gradient(135deg, #6E5199 0%,rgb(120, 58, 214) 100%)',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                padding: '12px 24px',
                fontSize: '14px',
                fontWeight: '600',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }}
            >
              <FaPrint />
              Download Receipt
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

// Enhanced Button Cell Renderer
class BtnCellRenderer extends Component {
  constructor(props) {
    super(props);
    this.btnClickedHandler = this.btnClickedHandler.bind(this);
  }

  btnClickedHandler() {
    const { data, clicked } = this.props;
    clicked(data);
  }

  render() {
    return (
      <button
        onClick={this.btnClickedHandler}
        style={{
          background: 'linear-gradient(135deg, #6E5199 0%,rgb(120, 58, 214) 100%)',
          color: 'white',
          border: 'none',
          borderRadius: '6px',
          padding: '8px 16px',
          fontSize: '12px',
          fontWeight: '600',
          cursor: 'pointer',
          transition: 'all 0.2s ease',
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          margin: '0 auto',
        }}
        onMouseEnter={(e) => {
          e.target.style.transform = 'translateY(-1px)';
          e.target.style.boxShadow = '0 4px 8px rgba(220, 53, 69, 0.3)';
        }}
        onMouseLeave={(e) => {
          e.target.style.transform = 'translateY(0)';
          e.target.style.boxShadow = 'none';
        }}
      >
        <FaEye size={12} />
        View
      </button>
    );
  }
}

export default PayOut;
